<div oui-dialog-title>
  Modifier une opération
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="dialog-content">
  <div class="form-container">
    @switch (data.champ) {
      @case ('montant') {
        <oui-textfield
          label="Montant"
          type="number"
          [control]="control"
          iconSuffix="euro"
          [allowWheelValueChange]="false"
          [showNumberStepper]="false"></oui-textfield>
      }
      @case ('contrepartieName') {
        <oui-textfield label="Nom de la contrepartie" [control]="control"></oui-textfield>
      }
      @case ('fondsEvenementiels') {
        <oui-select
          label="Fonds événementiel"
          [control]="control"
          [options]="fondsEvenementielsOptions"
          [multiple]="true"></oui-select>
      }
      @case ('tauxFrais') {
        <div class="multiple-select">
          <oui-select label="Type de taux de frais " [control]="control" [options]="typeTauxFraisOptions"></oui-select>
          @if (showSecondaryControl) {
            <oui-select
              label="Impact diminution des frais"
              [control]="secondaryControl"
              [options]="impactTauxFraisOptions"></oui-select>
          }
        </div>
      }
      @case ('typeSignaturePartenaire') {
        <div class="multiple-select">
          <oui-select
            label="Comment ont été signés les documents du partenaire ? (hors documents Stellium)"
            [control]="control"
            [options]="signatureOptions"></oui-select>
          @if (showSecondaryControl) {
            <oui-select
              label="Transmission des originaux"
              [control]="secondaryControl"
              [options]="transmissionListOptions"></oui-select>
          }
        </div>
      }
      @case ('transaction-personnelle') {
        <div>
          @if (transactionContextReady) {
          <app-transaction-personnelle
            [isPsi]="isPsiTransaction"
            [withCoInvestisseur]="withCoInvestisseur"
            [habilitationIds]="habiliationSet"
            [initValue]="currentValue"
            (onTransactionPersonnelleChange)="updateTransactionPersonelleStatut($event)"></app-transaction-personnelle>
          }
        </div>
      }
      @case ('modePaiement') {
        <oui-select
          label="Mode de paiement"
          [control]="control"
          [options]="modePaiementOptions"
          [multiple]="true"></oui-select>
      }
      @case ('objetModification') {
        <oui-select
          label="Objet de la modification"
          [control]="control"
          [options]="objetModificationOptions"
          [multiple]="false"></oui-select>
      }
    }
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button type="text" oui-dialog-close>Annuler</oui-button>
  <oui-button
    type="contained"
    (click)="saveOperation()"
    [disabled]="!control.valid || (showSecondaryControl && !secondaryControl.valid) || !canSave"
    >Enregistrer</oui-button
  >
</oui-dialog-actions>
